import { RootState } from 'reducers';

export const getTheme = (state: RootState) =>
    state.darkModeReducer.isDarkModeEnabled;
